var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#e8eef2"}},[_c('PCNavbar',{attrs:{"selectIndex":"5"}}),_c('MobileNavBar',{attrs:{"currentActive":4}}),_c('HangQing'),_c('HangQingList'),_c('CallMe'),_c('MobileCallme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }